import React, { useEffect, useState } from 'react';
import { Button, Col, Dropdown, DropdownButton, Form, Row } from 'react-bootstrap';
import {
    addKategoriesDataAPI,
    deleteCategoryAPI,
    getKategoriesDataAPI,
    updateKategoriesDataAPI
} from '../../API/kategories';
import { Save } from 'react-feather';
const { v4: uuidv4 } = require('uuid');

function KategorieComponent() {
    const [kategoriesData, setKategoriesData] = useState({});
    const [updateID, setUpdateID] = useState('');
    const [selectedKategorieName, setSelectedKategorieName] = useState('Bitte auswählen');
    const [selectedKategorieNameInitial, setSelectedKategorieNameInitial] = useState('Bitte auswählen');
    const [isUpdate, setIsUpdate] = useState(false);
    const [newCategory, setNewCategory] = useState('');

    useEffect(async() => {
        await getKategoriesDataAPI().then((data) => {
                data.sort((a, b) => a.category.localeCompare(b.category))
            setKategoriesData(data);
        });
    }, [kategoriesData]);

    function getKategorieDropdown() {
        let dropdownKategorieItems = '';

        // let defaultDropdownKategorieItem = (
        //     <Dropdown.Item
        //         key={0}
        //         onClick={() => {
        //             setIsUpdate(false);
        //             setSelectedKategorieName('');
        //             setSelectedKategorieNameInitial('Neue Kategorie erstellen');
        //         }}
        //     >
        //         {'Neue Kategorie erstellen'}
        //     </Dropdown.Item>
        // );

        if (kategoriesData !== '') {
            dropdownKategorieItems = Object.values(kategoriesData).map((item) => (
                <Dropdown.Item
                    key={item._id}
                    onClick={() => {
                        setUpdateID(item._id);
                        setSelectedKategorieName(item.category);
                        setSelectedKategorieNameInitial(item.category);
                        setIsUpdate(true);
                    }}
                >
                    {item.category}
                </Dropdown.Item>
            ));
        }
        return (
            <DropdownButton id="dropdown-basic-button" variant="dark" title={selectedKategorieNameInitial}>
                {dropdownKategorieItems}
                {/*{defaultDropdownKategorieItem}*/}
            </DropdownButton>
        );
    }

    function deleteCategory() {
        if (selectedKategorieName !== 'Bitte auswählen') {
            deleteCategoryAPI(updateID).then((r) => {
                if (r.status === 200) {
                    setKategoriesData(kategoriesData.filter(obj => obj._id !== updateID))
                    setSelectedKategorieName('Bitte auswählen')
                    setSelectedKategorieNameInitial('Bitte auswählen')
                    alert("Category " + selectedKategorieName + " deleted successfully");
                }
            });

        }
    }

    function handleSpeichern() {
        if (kategoriesData.filter(obj => obj.category === selectedKategorieName).length > 0) {
            alert("Category with the name " + selectedKategorieName + " already exists");
            return;
        }
        if (isUpdate) {
            updateKategoriesDataAPI(updateID, selectedKategorieName).then((r) => {
                if (r.status === 200) {
                    setSelectedKategorieName('Bitte auswählen')
                    setSelectedKategorieNameInitial('Bitte auswählen')
                    alert("Category " + selectedKategorieNameInitial + " updated")
                }
            });
        } else {
            alert('Lieber Analyst! Bitte wählen Sie Kategorie Name.');
        }
    }

    function addNewCategory() {
        if (newCategory === '') {
            return;
        }
        if (kategoriesData.filter(obj => obj.category === newCategory).length > 0) {
            alert("Category with the name " + newCategory + " already exists");
            return;
        }
        let createID = uuidv4();
            addKategoriesDataAPI(createID, newCategory).then((r) => {
                if (r.status === 200) {
                    kategoriesData.push({category_id: createID, category: newCategory});
                    kategoriesData.sort((a, b) => a.category.localeCompare(b.category));
                    alert("Category " + newCategory + " added successfully");
                }
            });
        setNewCategory('');
    }

    return (
        <>
            <Form>
                <label className="handwai-text-label-main handwai-black">Kategorien bearbeiten</label>

                <br />
                <br />
                <Form.Group as={Row}>
                    <Form.Label column sm="4">
                        Neue Kategorie
                    </Form.Label>
                    <Col sm="6">
                        <Form.Control
                            type="text"
                            value={newCategory}
                            onChange={(e) => setNewCategory(e.target.value)}
                        />
                    </Col>
                    <Col sm="2">
                        <Button variant="outline-success" block
                                onClick={() => addNewCategory()} disabled={newCategory === ''}>Hinzufügen</Button>
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Form.Label column sm="4">
                        Name Kategorie
                    </Form.Label>
                    <Col sm="6">
                        {getKategorieDropdown()}
                    </Col>
                    <Col sm="2">
                        <Button variant="outline-success" block
                                onClick={() => deleteCategory()}>Löschen</Button>
                    </Col>
                </Form.Group>

                <Form.Group as={Row}>
                    <Form.Label column sm="4">
                        Bearbeiten
                    </Form.Label>
                    <Col sm="8">
                        <Form.Control
                            type="text"
                            disabled={selectedKategorieName === 'Bitte auswählen'}
                            value={selectedKategorieName === 'Bitte auswählen' ? '' : selectedKategorieName}
                            onChange={(event) => setSelectedKategorieName(event.target.value)}
                        />
                    </Col>
                </Form.Group>

                <br />
            </Form>

            <br />
            <br />

            <Button size="lg" variant="outline-success" block onClick={() => handleSpeichern()}>
                <Save /> Speichern
            </Button>
        </>
    );
}

export default KategorieComponent;
